import dayjs from "dayjs";
import relativeTime from 'dayjs/plugin/relativeTime';
dayjs.extend(relativeTime);

export default {
  session: null,
  activeConversation: null,
  pausedConversation: null,

  setCurrentSession(messaging_mode_session) {
    this.session = messaging_mode_session;
  },

  setCurrentConversation(conversation) {
    this.activeConversation = conversation;
  },

  setPausedConversation(conversation) {
    this.pausedConversation = conversation;
  },

  get isReplyWindowModeActive() {
    return this.session?.mode === 'ReplyWindow';
  },
  get isManualModeActive() {
    return this.session?.mode === 'Manual';
  },
  get isAutomatedModeActive() {
    return this.session?.mode === 'Automated';
  },
  get replyWindowModeExpiration() {
    if (this.session?.mode === 'ReplyWindow') {
      const datetime = this.session.expires_at;
      return dayjs(datetime).format('M/D/YYYY h:mm:ss A z');
    }
  },
  get manualModeExpiration() {
    if (this.session?.mode === 'Manual') {
      const datetime = this.session.expires_at;
      return dayjs(datetime).format('M/D/YYYY h:mm:ss A z');
    }
  },
  get sessionTimeRemaining() {
    if (this.session?.expires_at) {
      const datetime = this.session.expires_at;
      return dayjs(datetime).fromNow(true);
    }
  },
  get hasActiveConversation() {
    return !!this.activeConversation?.id;
  },
  get activeConversationExpiration() {
    if (this.activeConversation) {
      let datetime = this.activeConversation.expires_at;
      return dayjs(datetime).format('M/D/YYYY h:mm:ss A z');
    }
  },
  get activeConversationName() {
    if (this.activeConversation) {
      return this.activeConversation.source_name;
    }
  },

  get hasPausedConversation() {
    return !!this.pausedConversation?.id;
  },
  get pausedConversationName() {
    if (this.pausedConversation) {
      return this.pausedConversation.source_name;
    }
  },
  get pausedConversationId() {
    if (this.pausedConversation) {
      return this.pausedConversation.id;
    }
  }
}
